import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { site } from '../data/site';
export function FinalCta() {
  return <section aria-labelledby="cta-title" className="relative overflow-hidden rounded-3xl border border-aurora-cyan/30 bg-night-800 p-8 md:p-12" data-id="element-191" data-mp="vghg9m2ai7nf">
      <div className="relative max-w-xl" data-id="element-192" data-mp="15ddgz5ly5phf">
        <h2 id="cta-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-4xl" data-id="element-193" data-mp="15capowkppl0z">
          Turn one manual process into a measurable win.
        </h2>
        <p className="mt-4 text-lg leading-8 text-muted" data-id="element-194" data-mp="1eejyni0c16c9">
          tkxel helps teams identify the right workflow, prove it with a focused POC and move it into
          production with AI agents, integrations, human approval and ongoing optimisation built in.
        </p>
        <a href={site.tkxelServiceUrl} target="_blank" rel="noopener" className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-xl bg-aurora-cyan px-6 py-3.5 font-semibold text-night transition-colors duration-150 hover:bg-cyan-300" data-id="element-195" data-mp="223mgoqyvp17a">
          Explore tkxel AI workflow automation
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="s5gws4n3crme" />
        </a>
      </div>
    </section>;
}